module.exports = __webpack_public_path__ + "static/img/invoice.c9ebf124.png";